import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/assets/style/index.scss';
import PUI from '@/components/pui/index.js';
import moment from 'moment';
import { ScaleHtmlFontSize } from '@/assets/ts/util';

import Component from 'vue-class-component';
// Register the router hooks with their names
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
]);

import VConsole from 'vconsole';
const isDebug = window.SERVER_CONFIG.APP_ENV === 'test';
    // && process.env.NODE_ENV !== 'development';
if (isDebug) {
    const vconsole = new VConsole();
}

Vue.config.productionTip = false;
Vue.config.ignoredElements = [
    'anboadv',
    /^wx-/,
];
Vue.prototype.$message = PUI.Message;
Vue.prototype.$confirm = PUI.Dialog.confirm;
Vue.prototype.$prompt = PUI.Dialog._prompt;
Vue.prototype.moment = moment;

Vue.directive('focus', (el: any) => {
    el.querySelector('input').focus();
});

Vue.mixin({
    computed: {
        AppEnv() {
            return store.state.appEnv;
        },

        EnvConfig() {
            let className: string;
            let province: string;
            let color: string;
            switch (store.state.appEnv) {
                default:
                    // no break
                case 'test':
                    // no break
                case 'prod':
                    className = 'rryb';
                    province = '桂';
                    color = '#f5a400';
                    break;
                case 'zo':
                    className = 'ybhome';
                    province = '粤';
                    color = '#1c89ca';
                    break;
            }

            return { className, province, color };
        },
    },
});

const scaleHtmlFontSize = new ScaleHtmlFontSize({
    designWidth: 375,
});
window._rryb_vue_ = new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');

function cnzz() {
    console.log('cnzz');
    if (document.getElementById('cnzz')) {
        const node = document.getElementById('cnzz') as HTMLElement;
        const parent = node.parentNode as HTMLElement;
        if (parent) {
            parent.removeChild(node);
        }
    }
    const script = document.createElement('script');
    script.setAttribute('id', 'cnzz');
    script.setAttribute('type', 'text/javascript');

    const span = document.createElement('span');
    span.setAttribute('id', 'cnzz_stat_icon_1278993017');
    span.setAttribute('style', 'display:block; width: 0; height: 0; overflow: hidden;');

    const scriptInner = document.createElement('script');
    scriptInner.setAttribute('src', 'https://v1.cnzz.com/z_stat.php?id=1278993017');
    scriptInner.setAttribute('type', 'text/javascript');

    script.appendChild(span);
    script.appendChild(scriptInner);
    document.body.appendChild(script);
}

cnzz();

router.beforeEach((to: any, from: any, next: (...args: any) => any) => {
    try {
        wx.miniProgram.getEnv((res: any) => {
            if (!res.miniprogram) {
                cnzz();
            }
        });
    } catch (err) {
        console.error(err);
        from.$message(err);
    } finally {
        next();
    }
});
